// Stripe.js no cliente. A publishable key (pk_) NÃO vem mais do .env: é buscada
// do backend (/billing/config), pois a config do Stripe é gerida no admin da
// plataforma. "Stripe só cobra": o valor vem do nosso backend; o front só confirma o cartão.
import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { apiFetch } from './api';

let pkCache: string | undefined; // undefined = ainda não buscado
let stripePromise: Promise<Stripe | null> | null = null;

async function fetchPk(): Promise<string> {
  if (pkCache !== undefined) return pkCache;
  const r = await apiFetch('GET', '/billing/config');
  pkCache = r.ok ? ((r.data as { publishable_key?: string })?.publishable_key ?? '') : '';
  return pkCache;
}

/** Carrega o Stripe.js com a pk do backend (null se não configurada). */
export async function getStripe(): Promise<Stripe | null> {
  const pk = await fetchPk();
  if (!pk) return null;
  if (!stripePromise) stripePromise = loadStripe(pk);
  return stripePromise;
}

/**
 * Promise ESTÁVEL p/ o <Elements>: o componente exige a MESMA referência de
 * Promise<Stripe|null> entre renders (trocar a referência reinicia o Element).
 * Resolve null se a pk não estiver configurada — o checkout transparente trata
 * isso mostrando o aviso "Stripe não configurado".
 */
export function stripePromiseFor(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = fetchPk().then((pk) => (pk ? loadStripe(pk) : null)).then((s) => s ?? null);
  }
  return stripePromise;
}
